(function () {
  var root = document.documentElement;
  var storageKey = 'radiant-hearts-color-mode';

  function updateToggle() {
    var dark = root.getAttribute('data-color-mode') === 'dark';
    var toggles = document.querySelectorAll('[data-color-mode-toggle]');

    for (var i = 0; i < toggles.length; i++) {
      var toggle = toggles[i];
      toggle.setAttribute('aria-pressed', dark ? 'true' : 'false');
    }
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest && event.target.closest('[data-color-mode-toggle]');
    if (!toggle) return;

    var dark = root.getAttribute('data-color-mode') !== 'dark';
    if (dark) {
      root.setAttribute('data-color-mode', 'dark');
    } else {
      root.removeAttribute('data-color-mode');
    }

    try {
      localStorage.setItem(storageKey, dark ? 'dark' : 'light');
    } catch (error) {
      // The switch remains usable when storage is unavailable.
    }
    updateToggle();
  });

  document.addEventListener('shopify:section:load', updateToggle);
  updateToggle();
}());
